import React, { useEffect } from 'react';
import { pxToRem } from '../util';
import GenderProgressScrollList from './GenderProgressScrollList';
import Segment from './Segment';
import CardHeader from './CardHeader';
const Box1 = (props: { charts: any }) => {
  const color = 'rgb(206, 234, 255)';
  const [index, setIndex] = React.useState(1);

  const [mainAbnormalIndicators, setMainAbnormalIndicators] = React.useState(
    []
  );
  const [mainMissedDetectionIndicators, setMainMissedDetectionIndicators] =
    React.useState([]);

  useEffect(() => {
    // 按照maleTotal+femaleTotal排序
    const sortedMainAbnormalIndicators = [
      ...(props.charts?.mainAbnormalIndicators || []),
    ].sort((a, b) => {
      const totalA = a.maleTotal + a.femaleTotal;
      const totalB = b.maleTotal + b.femaleTotal;
      return totalB - totalA; // 降序排序
    });
    setMainAbnormalIndicators(sortedMainAbnormalIndicators);

    const sortedMainMissedDetectionIndicators = [
      ...(props.charts?.mainMissedDetectionIndicators || []),
    ].sort((a, b) => {
      const totalA = a.maleTotal + a.femaleTotal;
      const totalB = b.maleTotal + b.femaleTotal;
      return totalB - totalA; // 降序排序
    });
    setMainMissedDetectionIndicators(sortedMainMissedDetectionIndicators);
  }, [props.charts]);

  return (
    <div
      style={{
        background:
          'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        height: `calc(57vh + 5px)`,
        maxHeight: `calc(57vh + 5px)`,
        overflow: 'hidden',
        padding: '5px',
        boxSizing: 'border-box',
        fontFamily: '阿里妈妈数黑体 Bold',
      }}
    >
      <CardHeader
        title="异常指标一览"
        subtitle="Mainly check for abnormalities"
      />
      <div style={{ height: '50vh', marginTop: pxToRem(10) }}>
        <Segment
          items={['主要异常指标', '主要漏检项目']}
          height={30}
          initialIndex={index}
          onChange={(i) => setIndex(i)}
        />
        <div style={{ height: pxToRem(10) }} />
        {index === 0 && (
          <GenderProgressScrollList
            data={mainAbnormalIndicators || []}
            personTotal={props.charts?.totalCharts?.archivesTotal || 0}
            height={'41vh'}
            rowHeight={33}
            visibleRows={10}
            scrollInterval={3000}
          />
        )}
        {index === 1 && (
          <GenderProgressScrollList
            data={mainMissedDetectionIndicators || []}
            personTotal={props.charts?.totalCharts?.archivesTotal || 0}
            height={'41vh'}
            rowHeight={33}
            visibleRows={10}
            scrollInterval={3000}
          />
        )}
        {/* 加个图例，标识男性女性 */}
        <div
          style={{
            display: 'flex',
            padding: pxToRem(20),
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: pxToRem(20),
            }}
          >
            <div
              style={{
                width: pxToRem(16),
                height: pxToRem(16),
                background: 'linear-gradient(90deg,#69c0ff,#1890ff)',
                marginRight: pxToRem(5),
              }}
            />
            <span style={{ color, fontSize: pxToRem(14) }}>男性</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                width: pxToRem(16),
                height: pxToRem(16),
                background: 'linear-gradient(90deg,#ffadd2,#f759ab)',
                marginRight: pxToRem(5),
              }}
            />
            <span style={{ color, fontSize: pxToRem(14) }}>女性</span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Box1;
